import { render, staticRenderFns } from "./SettingsSidebar.vue?vue&type=template&id=6dbc5442&"
import script from "./SettingsSidebar.vue?vue&type=script&lang=ts&"
export * from "./SettingsSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports